module.exports = __webpack_public_path__ + "img/tuscaloosa-county-schools-logo.65d57bc4.jpg";